import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { EntityCollectionServiceElementsFactory } from '@ngrx/data';
import {
  CLICommandDetailsInterface,
  CLICommandDetailsItemResponseInterface,
} from '@shared/api';
import { environment } from '@shared/environments';
import { Observable, tap } from 'rxjs';
import { CustomEntityCollectionBaseService } from '../entity-collection-base.class';
import { EntityTypeEnum } from '../entity.interface';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class CLICommandsService extends CustomEntityCollectionBaseService<CLICommandDetailsInterface> {
  private readonly http = inject(HttpClient);

  firstEntity$ = this.entities$.pipe(map((entities) => entities[0]));

  constructor(elementsFactory: EntityCollectionServiceElementsFactory) {
    super(EntityTypeEnum.CliCommand, elementsFactory);
  }

  createCommand(
    entity: CLICommandDetailsInterface,
  ): Observable<CLICommandDetailsInterface> {
    return this.add(entity);
  }

  createTemplateCommand(id: string): Observable<CLICommandDetailsInterface> {
    return this.http
      .post<CLICommandDetailsInterface>(
        `${environment.apiHost}/cli/template/${id}`,
        {},
      )
      .pipe(tap(() => this.refresh()));
  }

  loadCommandDetails(id: string): Observable<CLICommandDetailsInterface> {
    return this.http.get<CLICommandDetailsInterface>(
      `${environment.apiHost}/cli/command/${id}`,
    );
  }

  getCommandResponse(
    commandId: string,
    responseId: string,
  ): Observable<CLICommandDetailsItemResponseInterface> {
    return this.http.get<CLICommandDetailsItemResponseInterface>(
      `${environment.apiHost}/cli/command/${commandId}/response/${responseId}`,
    );
  }

  retryFailedCommand(id: string): Observable<CLICommandDetailsInterface> {
    return this.http
      .post<CLICommandDetailsInterface>(
        `${environment.apiHost}/cli/command/${id}/retry`,
        {},
      )
      .pipe(tap(() => this.refresh()));
  }
}
